

/**
 * Created by supunm on 1/21/19.
 */

(function () {
  'use strict';

  /**
   * @ngdoc service
   * @name languageDiscrepancy.service:languageDiscrepancyService
   *
   * @description
   *
   */
  angular
    .module('languageDiscrepancy')
    .service('languageDiscrepancyService', languageDiscrepancyService);

  function languageDiscrepancyService(CommonMasterData,RemoteService) {
    var vm = this;

    vm.searchLanguageDiscrepancy = function (param ,successFn,errorFn) {
      var searchParam = adaptSearchRequset(param);
      RemoteService.searchLanguageDiscrepancy(searchParam).then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    vm.searchActiveDistributionConfigIdentifiers = function (successFn,errorFn) {
      RemoteService.searchActiveDistributionConfigIdentifiers().then(
        function (response) {
          successFn(response);
        },
        function (error) {
          errorFn(error.msg);
        }
      );
    };

    function getDistributionGroupsList(distributionGroupsList) {
      const distributionGroups = [];
      angular.forEach(distributionGroupsList, function(distributionGroup) {
        distributionGroups.push(distributionGroup.distributionGroupCode);
      });
      return distributionGroups;
    }

    function adaptSearchRequset(param) {
      var actualSearchParam = {
        fromDate : param.fromDate,
        toDate: param.toDate,
        language: (param.language != null) ? param.language.languageCode : null,
        isLanguageMandatory: (param.mandatoryLanguageOption != null) ? param.mandatoryLanguageOption.mandatoryLanguageOptionCode : null,
        distributionGroupsList: (param.distributionGroupsList != null) ? getDistributionGroupsList(param.distributionGroupsList) : [],
        condition: param.condition ? "OR" : "AND",
      };
      return actualSearchParam;
    }

  }
}());
